import script from "./UsualScheduleSubpage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsualScheduleSubpage.vue?vue&type=script&lang=ts&setup=true"

import "./UsualScheduleSubpage.vue?vue&type=style&index=0&id=0aa67d8a&lang=scss"

const __exports__ = script;

export default __exports__